import requestHelper from '@/utils/requestHelper'

/**
 * 通过模板id获取上报gio的参数
 * @param data
 */
export async function getGioParamsByTempId(data = {}) {
  return requestHelper.post('v4/demand/template/gio/template/property', data)
}

/**
 * 通过作品id获取上报gio的参数
 * @param data
 */
export async function getGioParamsByWorkId(data = {}) {
  return requestHelper.post('v4/demand/template/gio/template/work/property', data)
}


/**
 * GIO离线事件埋点接口
 * @param data
 * @returns
 */
export async function eventBuryingPoint(data = {}) {
  return requestHelper.post('v4/demand/gio/offline/event/burying/point', data)
}
